import { Route } from '@/router/types'
import { CCP_SOFTPHONE_ROUTE_PATH } from '@/tokens/amazonCCP/types'

export const ccpSoftphoneRoute = (): Route => ({
  path: CCP_SOFTPHONE_ROUTE_PATH,
  name: '#ccpSoftphone',
  component: () => import('@/pages/CcpSoftphone/CcpSoftphonePage.vue'),
  meta: {
    title: 'CCP Softphone',
    permissionCheck: null,
    navless: true,
  },
})

export const ccpSoftphoneRoutes: Route[] = [ccpSoftphoneRoute()]
